<template>
  <div class="text-block blok-markdown" v-editable="blok">
    <div class="inner-block" :class="styleClasses" v-html="htmlText"></div>
  </div>
</template>

<script>
import Marked from 'marked'

export default {
  name: 'blok-text',
  props: ['blok'],
  computed: {
    htmlText() {
      return this.blok.text ? Marked(this.blok.text) : ''
    },
    styleClasses() {
      return this.blok.style || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.inner-block {
  padding: 20px;
}
.text-block ::v-deep %headings {
  margin: 0px;
  padding: 0px;
  margin-bottom: 10px;
  font-weight: 600;
}
.secondary-text-block {
  background-color: $secondary-bg;
  color: #000;
  border: 2px solid $secondary-border;
}
.main-text-block {
  background-color: $primary-bg;
  color: #fff;
  border: 2px solid $primary-border;
}
.main-text-block ::v-deep %headings {
  text-align: center;
}
.main-text-block ::v-deep {
  h1,
  h2 {
    color: $primary-accent-color;
    font-weight: bold;
  }
}
.secondary-text-block ::v-deep %headings {
  text-align: center;
}
.secondary-text-block ::v-deep {
  h1,
  h2 {
    color: $secondary-accent-color;
    font-weight: bold;
  }
}
</style>

<style>
.blok-markdown ol,
.blok-markdown ul {
  margin-left: 20px;
}
.blok-markdown ul li {
  list-style: disc outside none;
  display: list-item;
}
.blok-markdown ol li {
  list-style: decimal outside none;
  display: list-item;
}
.blok-markdown p {
  text-align: justify;
  padding: 0;
  margin-bottom: 10px;
}
.blok-markdown h1 {
  font-size: 2em;
}
.blok-markdown h2 {
  font-size: 1.5em;
}
.blok-markdown h3 {
  font-size: 1.17em;
}
.blok-markdown h4 {
  font-size: 1.12em;
}
.blok-markdown h5 {
  font-size: 0.83em;
}
.blok-markdown h6 {
  font-size: 0.75em;
}
</style>
